import '../../lib/globals'

import env from '@polleverywhere/core/lib/env'
import App from '../../lib/app'
import $ from 'jquery'
import URI from 'urijs'
import { peUrlParams } from './peUrlParams'
import { setupBrowserCheck } from './setupBrowserCheck'
import shouldStartSessionOnStart from '../../lib/util/should_start_session_on_start'

import '../../lib/components/skip_to_content'

import '../../lib/style.scss'

export function startApp (extraOpts = {}, appendTo = 'body') {
  const params = peUrlParams()

  let disabledFeatures = params.get('disabled') || ''
  disabledFeatures = disabledFeatures.split(',')

  // Extract auth token and remove from browser history (as we can't reuse)
  const sessionAuthToken = params.get('pe_auth_token') || false
  if (sessionAuthToken) {
    const uri = URI(window.location.href)
    window.history.replaceState('', '', uri.removeSearch('pe_auth_token').toString())
  }

  // Generate common options and merge with extra ones
  const opts = Object.assign({
    router: !disabledFeatures.includes('router'),
    debug: params.has('debug'),
    sessionAuthToken,
    shouldStartSessionOnStart: shouldStartSessionOnStart(),
    allowSignups: !disabledFeatures.includes('signups')
  }, extraOpts)

  /**
   * Setup the nginx proxy for sub-apps that require it
   * This is not used in development (env.get('proxy_enabled') == false) and in production
   * the ALB provides the /proxy functionality
   */
  if (opts.useApiProxy && env.get('proxy_xdomain_api')) {
    env.set('nginx_proxy_path', '/proxy')
    env.set('graphql_url', '/proxy/graphql')
  }

  const app = new App(opts)
  $(appendTo).append(app.$el)

  setupBrowserCheck({
    role: opts.role,
    mode: opts.mode,
    appName: opts.appName
  }, app)

  return app
}
